import { Component, h, Prop, Watch, Element } from '@stencil/core';
import * as echarts from 'echarts';

type EChartsOption = echarts.EChartsOption;

export interface ChartData {
  xData: string[] | number[];
  yData: string[] | number[];
}

const defaultOptions: EChartsOption = {
  title: [{
    text: "",
    left: "center",
  }],
  tooltip: {
    show: true,
  },
  xAxis: [
    {
      type: 'category',
      data: [],
    },
  ],
  yAxis: {
    type: 'value',
  },
  series: [
    {
      data: [],
      type: 'line',
      smooth: true
    },
  ],
};

@Component({
  tag: 'cr-line-chart',
  styleUrl: 'cr-line-chart.css',
  shadow: true,
})

export class CrLineChart {
  chartDom: any;
  eChart: echarts.ECharts;
  width: string = '100%';
  height: string = '100%';
  chartOptions: EChartsOption = defaultOptions;

  @Element() el: HTMLElement;
  @Prop() chartData: ChartData = {
    xData: [],
    yData: [],
  };

  @Prop() chartTitle: string = '';

  @Watch('chartData')
  @Watch('chartTitle')
  validateAndSetData() {
    this.setChartData()
    this.eChart.setOption(this.chartOptions);
  }

  connectedCallback() {
    this.width = this.el.parentElement.style.width || this.el.parentElement.clientWidth + 'px';
    this.height = this.el.parentElement.style.height || this.el.parentElement.clientHeight + 'px';
  }

  componentDidLoad() {
    this.setChartData()
    this.eChart = echarts.init(this.chartDom);
    this.eChart.setOption(this.chartOptions);
  }

  render() {
    return (
      <div style={{ height: this.height, width: this.width }} ref={el => (this.chartDom = el as HTMLDivElement)}></div>
    )
  }

  private verifyData = (data: ChartData) => {
    if (!data.xData || !data.yData) return false
    for (let value of Object.values(data)) {
      if (!(Array.isArray(value) && value.every((element: string | number) => (typeof element === 'string' || typeof element === 'number')))) return false
    }
    return true
  }

  private setChartData = () => {
    try {
      if (this.verifyData(this.chartData)) {
        this.chartOptions.xAxis[0].data = this.chartData.xData
        this.chartOptions.series[0].data = this.chartData.yData
        this.chartOptions.title[0].text = this.chartTitle
      } else {
        throw new Error('Invalid data')
      }
    } catch (error) {
      console.log(error)
    }
  }

}


